module.exports = __webpack_public_path__ + "static/media/Maven_3110.471cc917.jpg";